<template>
    
</template>

<script>
    export default {
        name: "IpsysHomeIndex"
    }
</script>

<style scoped>

</style>